import React, { useState, useRef, useCallback } from 'react';
import { useOutsideHandling } from '../Hooks/CustomHooks';
import { dynamicSort } from '../utilities';

const ContentfulBlockSelectState = (block) => {
    const [openSelect, setOpenSelect] = useState(false);
    let placeholder = block.placeholder ? block.placeholder : 'Select'
    const listStates = block.selectStates.sort(dynamicSort('contentName'))

    const selectRef = useRef(null);

    const toggleDropdown = useCallback(() => {
        setTimeout(() => {
            setOpenSelect(!openSelect);
        }, 100);
    }, [openSelect]);

    const handleClickOutsideSelect = useCallback(() => {
        setOpenSelect(false);
    }, []);
    useOutsideHandling(selectRef, handleClickOutsideSelect);


    return (
        <div className="select-box" ref={selectRef}>
            <div className="select-text">
                <button onClick={() => toggleDropdown()}>{placeholder}</button>
                <div onClick={() => toggleDropdown()} className={`arrow-down ${openSelect ? 'rotate' : ''}`}></div>
            </div>
            <div className="list-select-wrapper">
                <div className={`${openSelect ? 'show' : ''}`}>
                    <div className="list-select">
                        {
                            listStates.map((state, i) => (
                                <div key={state.contentName} className="select-item">
                                    <a tabIndex={openSelect ? 0 : -1} href={`/${state.slug}/`}>{state.contentName}</a>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export { ContentfulBlockSelectState }
